<template>
  <form class="form" autocomplete="off" v-on:submit.prevent="submit(email, password)">
    <div class="flex justify-center">
      <div class="pr-6 text-right hidden lg:block">
        <p class="body-10">SUBSCRIBER</p>
        <h5 class="mb-0 leading-none">LOG IN</h5>
      </div>
      <div class="flex">
        <div>
          <input
              id="email"
              type="text"
              v-model="email"
              name="email"
              placeholder="Username"
              v-validate="'required'"
          />
          <label class="body-9 lg:block hidden" for="email">Username</label>
        </div>
        <div>
          <input
              id="password"
              type="password"
              name="password"
              v-model="password"
              placeholder="Password"
              v-validate="'required'"
          />
          <div class="flex justify-between items-baseline">
            <label class="body-9 lg:block hidden" for="password">Password</label>
            <router-link class="log-1" to="forgot-password">Forgot my password</router-link>
          </div>
        </div>
        <div>
          <button class="btn body-6"  :disabled="pending || errors.any()">Log In</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'LoginForm',

    props: {
      pending: {
        default: false,
        type: Boolean
      }
    },

    data() {
      return {
        email: null,
        password: null
      };
    },

    methods: {
      submit(email, password) {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$emit('submit', {email: email, password: password});
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  a {
    @apply text-white;

    &:hover {
      @apply text-f1-d;
    }
  }

  p {
    @apply mb-0 leading-none text-white;
  }

  h5 {
    font-size: 30px;
  }

  .form {
    input {
      height: 40px;
      margin-right: 3px;
      @apply pl-1;

      @media (min-width: config('screens.xl')) {
        width: 236px;
      }
    }

    label {
      font-size: 16px;
      @apply font-normal normal-case text-white mb-0;
    }

    .btn {
      width: 92px;
      height: 40px;
      border-radius: 0 50px 50px 0;
      @apply bg-grey-2 text-white m-0 p-0;

      &:hover {
        @apply bg-grey-2 text-f1-c;
      }
    }
  }
</style>
